import { analyticsTrack } from "../utils/analytics";
import { parseStructuredDataJSON } from "../utils/structured-data";
import { logger } from "./logger";

export function install() {
  const schemaElements = document.querySelectorAll<HTMLScriptElement>(
    'script[type="application/ld+json"]'
  );

  schemaElements.forEach((schemaElement) => {
    const schema = parseStructuredDataJSON(schemaElement, logger);
    const offer = schema["offers"] || {};

    if (schema["@type"] === "Product") {
      analyticsTrack("Product Viewed", {
        application: "ff8",
        sku: schema["productID"],
        brand: schema["brand"],
        name: schema["name"],
        url: window.location.href,
        // eslint-disable-next-line @typescript-eslint/camelcase
        image_url: schema["image"],
        currency: offer["priceCurrency"],
        price: Number(offer["price"] || 0),
      });
    }
  });
}
